import type { RouteLocation, RouteLocationRaw } from 'vue-router'

const HANDOFF_QUERY_KEYS = ['access_token', 'refresh_token', 'company_id', 'setup_company_id'] as const

export interface UrlHandoffParams {
  refreshToken: string
  companyId?: number
}

/**
 * O vue-router entrega um array quando o mesmo param aparece repetido na URL.
 * Sem normalizar, `.toString()` juntaria os valores com vírgula e produziria um
 * refresh token corrompido que ainda passaria em qualquer teste de comprimento.
 */
function readSingleParam (value: RouteLocation['query'][string]): string {
  return (Array.isArray(value) ? value[0] : value)?.toString() ?? ''
}

export function readUrlHandoffParams (route: RouteLocation): UrlHandoffParams {
  const companyIdParam = readSingleParam(route.query.setup_company_id) || readSingleParam(route.query.company_id)
  const parsedCompanyId = companyIdParam.length > 0 ? Number.parseInt(companyIdParam, 10) : Number.NaN

  return {
    refreshToken: readSingleParam(route.query.refresh_token),
    companyId: Number.isNaN(parsedCompanyId) ? undefined : parsedCompanyId
  }
}

export function buildCleanLocation (route: RouteLocation): RouteLocationRaw | undefined {
  const query = { ...route.query }
  const keysToRemove = HANDOFF_QUERY_KEYS.filter(key => key in query)

  if (keysToRemove.length === 0) {
    return undefined
  }

  for (const key of keysToRemove) {
    delete query[key]
  }

  return {
    path: route.path,
    query,
    hash: route.hash
  }
}
